// Path: ./src/app/pages/CreatePreferenceWatchItemPage/handleSaveWatchItem.ts
import { useNavigate } from "react-router-dom";
import {
  CreateGfPreferenceWatchItemDto,
  UpdateGfPreferenceWatchItemDto,
} from "@swagger/typescript-fetch-goflyer";
import i18n from "i18next";

import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { useLoading } from "../../../contextApi/LoadingContext";
import { useAuthHeaders } from "../../../hooks/useAuthHeaders";
import {
  WatchItemFormState,
  buildWatchItemPayload,
} from "../../../utils/preference/watchItemPayload";

export const useHandleSaveWatchItem = () => {
  const navigate = useNavigate();
  const { showLoadingScreen } = useLoading();
  const authHeaders = useAuthHeaders();

  return async (form: WatchItemFormState, watchItemId?: string) => {
    if (!form.name.trim()) {
      toastError(i18n.t(messages.preference_watch_item_name_required()));
      return;
    }

    const payload = buildWatchItemPayload(form);

    showLoadingScreen(true);
    const result = watchItemId
      ? await adminApiService.updateOneBaseGfPreferenceWatchItemAdminControllerGfPreferenceWatchItem(
          payload as UpdateGfPreferenceWatchItemDto,
          watchItemId,
          authHeaders,
        )
      : await adminApiService.createOneBaseGfPreferenceWatchItemAdminControllerGfPreferenceWatchItem(
          payload as unknown as CreateGfPreferenceWatchItemDto,
          authHeaders,
        );
    showLoadingScreen(false);

    if (result === undefined) return;

    toastSuccess(
      i18n.t(
        watchItemId
          ? messages.preference_watch_item_update_success()
          : messages.preference_watch_item_create_success(),
      ),
    );
    navigate(-1);
  };
};
